// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3cFB7","dragIcon":"SortableItem_dragIcon__2bGs4","disabled":"SortableItem_disabled__1s0Co"};